import React, { FC } from 'react';

import { EAssetType } from 'constants/enums';

import {
  DEFAULT_BUILTIN_ANIMATION_LOADER,
  DEFAULT_BUILTIN_ANIMATION_LOADER_URL,
  DEFAULT_BUILTIN_FAVICON,
  DEFAULT_BUILTIN_FAVICON_URL,
  DEFAULT_BUILTIN_PLAYER_PROFILE,
  DEFAULT_BUILTIN_PLAYER_PROFILE_URL
} from '../constants';

import MediaContentItem from './MediaContentItem';
import { MediaContentProps } from './types';

const MediaContent: FC<MediaContentProps> = ({
  handleImageDelete,
  selectedImageUrl,
  onSelectImage,
  searchQuery,
  images = [],
  onDoubleClick,
  setIsCopying,
  forceType
}) => {
  const filteredImages = images.filter(
    ({ name, type }) =>
      name.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (forceType ? type === forceType : true)
  );

  const userImagesSorted = [...filteredImages].reverse();

  const builtinByForceType: Partial<
    Record<EAssetType, { row: (typeof DEFAULT_BUILTIN_ANIMATION_LOADER); url: string }>
  > = {
    [EAssetType.ANIMATION]: {
      row: DEFAULT_BUILTIN_ANIMATION_LOADER,
      url: DEFAULT_BUILTIN_ANIMATION_LOADER_URL
    },
    [EAssetType.FAVICON]: {
      row: DEFAULT_BUILTIN_FAVICON,
      url: DEFAULT_BUILTIN_FAVICON_URL
    },
    [EAssetType.PLAYER_PROFILE_IMG]: {
      row: DEFAULT_BUILTIN_PLAYER_PROFILE,
      url: DEFAULT_BUILTIN_PLAYER_PROFILE_URL
    }
  };

  const builtin = forceType ? builtinByForceType[forceType] : undefined;

  const displayImages =
    builtin &&
    !filteredImages.some((img) => img.url === builtin.url)
      ? [builtin.row, ...userImagesSorted]
      : userImagesSorted;

  return (
    <div className="max-h-[360px] overflow-y-auto">
      <div className="grid grid-cols-4 gap-2 my-4">
        {displayImages.map(({ name, url, type, mediaId, mimeType }, i) => (
          <MediaContentItem
            handleImageDelete={handleImageDelete}
            name={name}
            url={url}
            type={type}
            mediaId={mediaId}
            mimeType={mimeType}
            key={`${mediaId}-${i}`}
            isSelected={selectedImageUrl === url}
            onSelect={() => onSelectImage(url)}
            onDoubleClick={onDoubleClick}
            setIsCopying={setIsCopying}
          />
        ))}
      </div>
    </div>
  );
};

export default MediaContent;
